import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PAGE_INDEX, PAGE_SIZE } from '~/utils/constants/common';
import { handleGetLocationList } from './locationThunk';
import { SortDirectionEnum } from '~/utils/enum';
import { ILocation, IParamsGetLocation } from '~/utils/interface/location';

export interface LocationState {
  locations: Array<ILocation>;
  filter: IParamsGetLocation;
  totalItems: number;
  needRefreshData: boolean;
}

const initialState: LocationState = {
  locations: [],
  totalItems: 0,
  needRefreshData: false,
  filter: {
    username: '',
    search: '',
    searchBy: '',
    sortBy: '',
    startDate: '',
    endDate: '',
    provinceId: '',
    wardId: '',
    assigned: undefined,
    location_type: undefined,
    sortOrder: SortDirectionEnum.DESC,
    pageIndex: PAGE_INDEX,
    pageSize: PAGE_SIZE,
  },
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IParamsGetLocation>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    resetFilter: (state) => {
      state.filter = initialState.filter;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetLocationList.pending, (_state, _action) => {})
      .addCase(handleGetLocationList.fulfilled, (state, action) => {
        const data = action.payload?.result?.data;
        state.locations = Array.isArray(data) ? data : [];
        state.totalItems = action.payload.result.total_record || 0;
        state.needRefreshData = false;
      })
      .addCase(handleGetLocationList.rejected, (_state, _action) => {});
  },
});

export const locationActions = locationSlice.actions;

const locationReducer = locationSlice.reducer;
export default locationReducer;
